import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link", "checkbox"];

  connect() {
    this.updateLink();
  }

  updateLink() {
    const checkedIds = this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.value);

    const url = new URL(this.linkTarget.href);

    // Remove existing ticket_type_ids params
    const params = new URLSearchParams(url.search);
    const keysToDelete = [];
    for (const key of params.keys()) {
      if (key.startsWith("ticket_type_ids")) {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach((key) => params.delete(key));

    // Add current checked ids
    checkedIds.forEach((id) => {
      params.append("ticket_type_ids[]", id);
    });

    url.search = params.toString();
    this.linkTarget.href = url.toString();
  }
}
